export default __webpack_public_path__ + "static/media/ass-result1.7c1422c0.gif";